import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import { ref, computed, onMounted, watch } from "vue";
import { message, Modal } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import XDialog from "@/components/XDialog.vue";
import { adsSourceList, adsSourceCreate, adsSourceDel } from "@/api/api";
import type { FormInstance } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsSource',
  props: {
  isRefresh: {
    type: Boolean,
    default: false,
  },
  dateTime: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const addDialogVisible = ref(false);
const addForm = ref({
  id: undefined,
  remark: "",
  url: "",
});
const addFormRef = ref<FormInstance>();
const addLoading = ref(false);
const addFormRules = {
  remark: [{ required: true, message: "请输入广告标题" }],
  url: [{ required: true, message: "请输入广告地址" }],
};

const props = __props;

watch(() => props.isRefresh, (newVal: boolean) => {
  if (newVal) {
    getList();
  }
});

watch(() => props.dateTime, (newVal: string) => {
  //console.log(newVal);
  if (newVal) {
    getList();
  }
});

const columns = ref([
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: "归属",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "广告地址",
    dataIndex: "url",
    key: "url",
  },
  //   {
  //     title: "创建时间",
  //     dataIndex: "createdAt",
  //     key: "createdAt",
  //     width: 180,
  //     isAllTime: true,
  //   },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 150,
    },
]);

const openAddDialog = () => {
  addDialogVisible.value = true;
  addForm.value = { id: undefined, remark: "", url: "" };
  addFormRef.value?.resetFields();
};

const closeAddDialog = () => {
  addDialogVisible.value = false;
};

const openEditDialog = (record: any) => {
  addDialogVisible.value = true;
  addForm.value = { ...record };
  addFormRef.value?.resetFields();
};

const handleAddAdsSource = async () => {
  if (!addFormRef.value) return;
  try {
    await addFormRef.value.validate();
    addLoading.value = true;
    const params = { ...addForm.value };
    const res = await adsSourceCreate(params);
    if (res.code === "200") {
      message.success(addForm.value.id ? "修改成功" : "添加成功");
      closeAddDialog();
      getList();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示
  } finally {
    addLoading.value = false;
  }
};

const deleteAdsSource = (record: any) => {
  Modal.confirm({
    title: "确认删除该广告源？",
    content: `归属：${record.remark}`,
    okText: "确定",
    cancelText: "取消",
    onOk: async () => {
      try {
        const res = await adsSourceDel({ id: record.id });
        if (res.code === "200") {
          message.success("删除成功");
          getList();
        } else {
          message.error(res.msg || "删除失败");
        }
      } catch (error) {
        message.error("删除失败");
        console.error("删除广告源失败:", error);
      }
    },
  });
};

onMounted(() => {
  getList();
});

const onPageChange = (page: number) => {
  pageNo.value = page;
  getList();
};

const getList = () => {
  loading.value = true;
  adsSourceList({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    dateTime: props.dateTime,
  })
    .then((res) => {
      tableData.value = res.data.records || [];
      total.value = res.data.total || 0;
    })
    .catch((e) => {
      message.error("获取广告源列表失败");
    })
    .finally(() => {
      loading.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: openAddDialog,
        style: {"margin-bottom":"16px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加广告源")
        ]),
        _: 1
      }),
      _createVNode(XTable, {
        columns: columns.value,
        "data-source": tableData.value,
        loading: loading.value,
        rowKey: "id",
        bordered: "",
        pagination: false
      }, {
        action: _withCtx(({ record }) => [
          _createElementVNode("a", {
            onClick: ($event: any) => (openEditDialog(record))
          }, "编辑", 8, _hoisted_1),
          _createVNode(_component_a_divider, { type: "vertical" }),
          _createElementVNode("a", {
            onClick: ($event: any) => (deleteAdsSource(record))
          }, "删除", 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading"]),
      _createVNode(_component_a_pagination, {
        current: pageNo.value,
        "page-size": pageSize.value,
        total: total.value,
        onChange: onPageChange,
        style: {"margin-top":"16px","text-align":"right"}
      }, null, 8, ["current", "page-size", "total"])
    ]),
    _createVNode(XDialog, {
      visible: addDialogVisible.value,
      title: "添加广告源",
      xWidth: "400px",
      onCancel: closeAddDialog,
      onConfirm: handleAddAdsSource,
      confirmLoading: addLoading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          model: addForm.value,
          rules: addFormRules,
          ref_key: "addFormRef",
          ref: addFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "归属",
              name: "remark",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addForm.value.remark,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((addForm.value.remark) = $event)),
                  placeholder: "请选择归属",
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "第三方" }, {
                      default: _withCtx(() => [
                        _createTextVNode("第三方")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "自营" }, {
                      default: _withCtx(() => [
                        _createTextVNode("自营")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "广告地址",
              name: "url",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addForm.value.url,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addForm.value.url) = $event)),
                  placeholder: "请输入广告地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}
}

})